import { THEME } from "../utils/constants.js";
// import { darkblueYellowTheme } from "./darkblueYellowTheme.js";
import { redGreenTheme } from "./redGreenTheme.js";
import { darkTealPinkTheme } from "./darkTealPinkTheme.js";
/**
 * Generates a Material-UI dark theme palette with the specified primary and secondary colors.
 *
 * @param {string} primaryColor - The primary color for the theme (e.g., '#000000').
 * @param {string} secondaryColor - The secondary color for the theme (e.g., '#ffffff').
 * @param {boolean} [red=true] - Optional flag to apply a red accent or tint. Defaults to true.
 * @returns {object} An MUI palette object with the specified colors and dark mode enabled.
 */
const getTheme = (theme) => {
  switch (theme) {
    // case THEME.DARK_BLUE_YELLOW_THEME:
    //   return darkblueYellowTheme;
    case THEME.DARK_TEAL_PINK_THEME:
      return darkTealPinkTheme;
    case THEME.RED_GREEN_THEME:
      return redGreenTheme;
    default:
      return darkTealPinkTheme;
  }
};

export default getTheme;
